import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Navigate, Route, Routes } from 'react-router-dom'

import { AppShell } from '@/components/layout/AppShell'
import { ErrorBoundary } from '@/components/layout/ErrorBoundary'
import { ToastProvider } from '@/hooks/useToast'
import { ApiError } from '@/lib/apiClient'
import { DashboardPage } from '@/pages/DashboardPage'
import { IngestPage } from '@/pages/IngestPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { SearchPage } from '@/pages/SearchPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 4xx is the server telling us the request was wrong; retrying it
      // cannot help, so only retry transport and 5xx failures.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) return false
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <Routes>
          <Route element={<AppShell />} path="/">
            <Route
              index
              element={
                <ErrorBoundary>
                  <SearchPage />
                </ErrorBoundary>
              }
            />
            <Route
              path="dashboard"
              element={
                <ErrorBoundary>
                  <DashboardPage />
                </ErrorBoundary>
              }
            />
            <Route
              path="ingest"
              element={
                <ErrorBoundary>
                  <IngestPage />
                </ErrorBoundary>
              }
            />
            <Route path="jobs" element={<Navigate replace to="/ingest" />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </ToastProvider>
    </QueryClientProvider>
  )
}
